import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { List, Map } from 'immutable';
// import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/core/Typography';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
// import { makeStyles } from '@material-ui/core/styles';
// import theme from '../../../common/theme';
import { SingleStep } from '../pathway_candidate_details/candidate_step/candidate_step_view';
// import CandidateStatusRow from './candidate_status_row';
import { useFetchOnce } from '../../../util/hooks';
import UserModel from '../../../session/models/user_model';
import Spinner from '../../../common/components/spinner';
import { PathwayStepCandidate } from './pathway_step_styles';

// const useStyles = makeStyles(() => ({
//   progressBar: {
//     height: '12px',
//     borderRadius: '10px',
//     maxWidth: '400px',
//     backgroundColor: theme.color.grayLighter,
//     '& > div': {
//       backgroundColor: theme.color.greenLight,
//       borderRadius: '10px',
//     },
//   },
//   candidatesCompletedText: {
//     fontWeight: 'bold',
//     color: theme.color.greenLight,
//     marginBottom: '10px',
//   },
//   rowsHeader: {
//     padding: '0px 24px',
//     margin: '18px 0px 6px',
//     '& span': {
//       lineHeight: 1,
//     },
//   },
// }));

const PathwayStepDetailsView = ({
  user,
  pathwayStepId,
  pathwayInstanceId,
  pathwayInstance,
  candidatePathways,
  fetchPathwayInstance,
  listCandidatePathwaysForPathwayInstance,
}) => {
  // const classes = useStyles();

  useFetchOnce(user, pathwayInstanceId, fetchPathwayInstance, pathwayInstance);
  useFetchOnce(user, pathwayInstanceId, listCandidatePathwaysForPathwayInstance, candidatePathways);

  if (!pathwayInstance || !candidatePathways) {
    return <Spinner />;
  }

  const pathwayStep = pathwayInstance
    .getIn(['pathway', 'pathwayMilestones'])
    .map((x) => x.getIn(['pathwayMilestone', 'pathwaySteps']))
    .flatten(1)
    .find((x) => x.get('id') === pathwayStepId);

  return (
    <div>
      <div>
        <Link to={`/staff/pathways/${pathwayInstanceId}`}>
          <Button color="primary" size="small" startIcon={<KeyboardBackspaceIcon />}>
            Back to Pathway
          </Button>
        </Link>
      </div>
      <h1>
        Pathway Name: {pathwayInstance.get('name')} Step Name: {pathwayStep.get('name')}{' '}
      </h1>
      {/* <Typography variant="h6" className={classes.candidatesCompletedText}> */}
      {/*  4/10 Candidates Completed */}
      {/* </Typography> */}
      {/* <LinearProgress variant="determinate" value={40} className={classes.progressBar} color="secondary" /> */}
      {/* <TextField */}
      {/*  id="search" */}
      {/*  placeholder="Search" */}
      {/*  margin="dense" */}
      {/*  variant="outlined" */}
      {/*  fullWidth */}
      {/*  InputProps={{ */}
      {/*    startAdornment: ( */}
      {/*      <InputAdornment position="start"> */}
      {/*        <SearchIcon /> */}
      {/*      </InputAdornment> */}
      {/*    ), */}
      {/*  }} */}
      {/* /> */}
      {/* <Grid container justify="space-between" alignItems="center" spacing={2} className={classes.rowsHeader}>
        <Grid item xs={1} />
        <Grid item xs={3}>
          <Typography variant="overline">Candidate</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="overline">Target Completion</Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="overline">Actual Completion</Typography>
        </Grid>
        <Grid item container xs={4} justify="center">
          <Typography variant="overline">Status</Typography>
        </Grid>
      </Grid> */}
      {candidatePathways.map((candidatePathway) => {
        const pathwayInstanceStep = candidatePathway.get('pathwayInstanceSteps').find((x) => x.get('pathwayStepId') === pathwayStepId);

        return (
          <PathwayStepCandidate key={candidatePathway.get('id')}>
            <div className="link-wrapper">
              <h4>
                <Link className="candidate-link" to={`/staff/candidates/${candidatePathway.getIn(['candidate', 'candidateId'])}`}>
                  {candidatePathway.getIn(['candidate', 'user', 'firstName'])}
                  &nbsp;{candidatePathway.getIn(['candidate', 'user', 'lastName'])}
                </Link>
              </h4>
              <Link className="pathway-link" to={`/staff/pathways/${pathwayInstanceId}/candidates/${candidatePathway.get('id')}`}>
                View Pathway
              </Link>
            </div>

            <SingleStep
              step={pathwayStep}
              candidatePathwayId={candidatePathway.get('id')}
              pathwayInstanceStep={pathwayInstanceStep}
              key={candidatePathway.get('id')}
            />
          </PathwayStepCandidate>
        );
      })}
    </div>
  );
};

PathwayStepDetailsView.propTypes = {
  user: PropTypes.instanceOf(UserModel).isRequired,
  pathwayStepId: PropTypes.string.isRequired,
  pathwayInstanceId: PropTypes.string.isRequired,
  pathwayInstance: PropTypes.instanceOf(Map),
  fetchPathwayInstance: PropTypes.func.isRequired,
  listCandidatePathwaysForPathwayInstance: PropTypes.func.isRequired,
  candidatePathways: PropTypes.instanceOf(List),
};
PathwayStepDetailsView.defaultProps = {
  pathwayInstance: undefined,
  candidatePathways: undefined,
};

export default PathwayStepDetailsView;
